import React from 'react'
import { useSelector } from 'react-redux'

import NewsroomNews from '../newsroomNews'
import SliderContent from '../sliderContent'
import PushContent from '../pushContent'

import trads from '../../intl/trads.json'

const Hub = ({pushPages, events, news, documents, pressReleases, socials, lang: propLang}) => {
  const storeLang = useSelector(state => state.lang)
  const lang = propLang || storeLang

  return (
    <div className="newsroom-hub">
      <NewsroomNews news={news} socials={socials} lang={lang} />
      
      { events && events.length > 0 &&
        <SliderContent
          title={trads[lang].newsroom.events}
          items={events}
          contentType="event"
          hasCta={true}
          lang={lang} />
      }

      { pressReleases && pressReleases.length > 0 &&
          <SliderContent  
            title={trads[lang].newsroom.pressReleaseTitle}
            items={pressReleases}
            contentType="press"
            hasCta={true}
            lang={lang} />
        }

      { documents && documents.length > 0 &&
        <SliderContent  
          title={trads[lang].newsroom.documents}
          items={documents}
          contentType="publi"
          hasCta={true}
          lang={lang} />
      }

      <PushContent data={pushPages} />
    </div>
  )
}

export default Hub